import Thumbnail from './Thumbnail';

export default Thumbnail;
export * from './interface';
